import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _styled from "@emotion/styled-base";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { ie10Plus } from "../utils/cssSelectors";
import _Tooltip from "../Tooltip";
export var TruncateRoot =
/*#__PURE__*/
_styled('span', {
  target: "e1i5p1da0"
})(function (_ref) {
  var _focus;

  var showTooltip = _ref.showTooltip,
      baseTheme = _ref.theme;
  return _objectSpread({}, showTooltip ? {
    pointerEvents: 'all'
  } : undefined, {
    display: "inline-block",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    wordWrap: "normal"
  }, {
    '&:focus': (_focus = {
      outline: "1px solid " + baseTheme.borderColor_theme_focus,
      outlineOffset: -1
    }, _focus[ie10Plus] = {
      outline: 'none'
    }, _focus)
  });
});
export var Tooltip =
/*#__PURE__*/
_styled(_Tooltip, {
  target: "e1i5p1da1"
})({
  name: "xs9fqv",
  styles: "white-space:normal;"
});